import { faXmark } from '@fortawesome/pro-solid-svg-icons'

import { Icon } from 'Components/Icon/Icon'

import type { PortalReturnLabelModalGhostXButtonProps } from './PortalReturnLabelModal.types'

export const PortalReturnLabelModalGhostXButton = ({
  ariaLabel,
  onClick,
}: PortalReturnLabelModalGhostXButtonProps) => (
  <button
    aria-label={ariaLabel}
    className="PortalReturnLabelModal-ghostXButton"
    onClick={onClick}
    type="button"
  >
    <Icon icon={faXmark} size={16} />
  </button>
)
